import React, { useState } from 'react';
import { Field, FieldProps } from 'formik';
import { Checkbox } from 'vendors/semantic-ui';

import { GroupCheckboxesControlProps } from './group-checkboxes-control-type';
import { GroupCheckboxesOption } from '../..';

import styles from './group-checkboxes-control-component.module.css';

export const GroupCheckboxesInputControl: React.FC<GroupCheckboxesControlProps> = ({
    name,
    options,
    onChange,
    ...rest
}: GroupCheckboxesControlProps) => {
    const [selection, setSelection] = useState<GroupCheckboxesOption[]>(options);

    return (
        <Field
            name={name}
            render={({ form }: FieldProps) => {
                return (
                    <div className={styles.rootContainer}>
                        {options.map((option, index) => {
                            return (
                                <Checkbox
                                    className={styles.checkboxItem}
                                    onChange={(_, data) => {
                                        const newSelection = selection;
                                        newSelection[index].checked = data.checked || false;
                                        setSelection(newSelection);
                                        form.setFieldValue(name, newSelection);
                                        if (onChange) {
                                            onChange(newSelection);
                                        }
                                    }}
                                    {...option}
                                />
                            );
                        })}
                    </div>
                );
            }}
            {...rest}
        />
    );
};
